import { createContext, useContext } from 'react'

/**
 * How `Currency` spells amounts under a subtree. `stableAsDollar` renders a stablecoin
 * (USDC, USDT) as "$10.00" instead of "10.00 USDC", for surfaces that already talk about
 * real money in dollars. Explicit `prefix` / `suffix` props on a `Currency` still win.
 */
const CurrencyDisplayContext = createContext({ stableAsDollar: false })

export const CurrencyDisplayProvider = CurrencyDisplayContext.Provider

export const useCurrencyDisplay = () => useContext(CurrencyDisplayContext)
